module.exports = __webpack_public_path__ + "static/img/smiling2.46e84cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smiling2.jpg
// module id = 345
// module chunks = 2